import Link from "next/link";
import { PrimaryButton } from "@components/UI/Buttons/PrimaryButton/PrimaryButton";
import { Pagination } from "@widgets/Pagination";
import { BlogSort } from "@features/blog";
import { BlogCard } from "@entities/blog";
import { RouterConfig } from "@shared/lib/routerConfig";
import { Container } from "@shared/ui/container";
import { BlogCatalogueProps } from "./types";
import classes from "./blog-catalogue.module.scss";

export const BlogCatalogue = ({
    posts,
    pagesCount,
    currentPage,
    isAuthorPage = false
}: BlogCatalogueProps) => {
    const h1Text = currentPage > 1 ? `Блог — Страница ${currentPage}` : "Блог";

    if (posts.length === 0) {
        return (
            <Container>
                <div className={classes.Error}>
                    <h2>К сожалению, такой страницы нет.</h2>
                    <Link href={RouterConfig.BLOG}>
                        <PrimaryButton type="Large" content={"К статьям"} />
                    </Link>
                </div>
            </Container>
        );
    }

    return (
        <div className={classes.blog}>
            <Container>
                <div className={classes.blog__header}>
                    {!isAuthorPage && <h1 className={classes.blog__title}>{h1Text}</h1>}
                    <BlogSort />
                </div>

                <div className={classes.blog__cards}>
                    {posts.map((item) => {
                        if (item.status === "publish" && item.slug) {
                            return (
                                <BlogCard
                                    slug={item.slug}
                                    title={item.title?.rendered ?? ""}
                                    date={item.date}
                                    image={
                                        item.x_featured_media_large ??
                                        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mO8f/d+PQAIWgMcDMOFRwAAAABJRU5ErkJggg=="
                                    }
                                    authorName={item.x_author}
                                    avatarLink={item.x_gravatar}
                                    views={item.views ?? null}
                                    key={item.id}
                                    withBorder
                                    hideAuthor={isAuthorPage}
                                />
                            );
                        }
                    })}
                </div>
                {pagesCount > 1 && (
                    <Pagination
                        className={classes.blog__pagination}
                        totalPages={pagesCount}
                        currentPage={currentPage}
                    />
                )}
            </Container>
        </div>
    );
};